'use client';

import type { FeatureFlagName } from '@/libs/feature-flags/flags';
import { useFlag } from '@unleash/nextjs/client';

export function useFeatureFlag(flag: FeatureFlagName): boolean {
  return useFlag(flag);
}
